import React, { useState } from 'react'
import { useNavigate } from "react-router-dom";
import LoginForm from './LoginForm'
import PasswordResetForm from './PasswordResetForm';


const ProjectManagerAccessPortal = ({ firstLogin }) => {
  const navigate = useNavigate()
  const [showReset, setShowReset] = useState(firstLogin || false)

  const processSubmitRoute = (firstLogin) => {
    if (firstLogin === true) {
      setShowReset(true)
    } else {
      navigate('/project_manager/campaigns')
    }
  }

  const BaseTitle = () => (
    <div className='flex justify-center align-center mb-5 z-5'>
      <img src="/static/reachbird_logo.png" alt="Logo" className="h-7" />
      <h1 className='pl-2 text-center align-middle text-2xl font-bold'>Reachbird</h1>
    </div>
  )

  const AdminPassTitle = () => (
    <div className='mb-7 flex flex-col justify-center z-5'>
      <h1 className='text-center align-middle text-3xl font-bold'>Welcome to the platform</h1>
      <p className='text-center font-thin'>Influencer Marketing Technology</p>
    </div>
  )

  return (
    <div className='flex h-screen w-screen bg-rb-grey relative overflow-hidden'>
      <img src="/static/background_images/login-shape-left.png" alt="bottom corner lines" className='absolute -bottom-40 -left-40 -z-5' />
      <img src="/static/background_images/login-shape-right.png" alt="top corner lines" className='absolute -top-40 -right-40 -z-5' />
      <div className="m-auto">
        {showReset ? <AdminPassTitle /> : <BaseTitle /> }
        <div
          className='flex flex-col justify-between align-center bg-white rounded-lg p-6 relative'
          style={{ height: `${showReset ? 500: 400}`, width: 320 }}
        >
          {
            showReset ? (
              <PasswordResetForm />
            ) : (
              <LoginForm processSubmit={processSubmitRoute} />
            )
          }
        </div>
        { showReset && (
          <div className="mt-7">
            <BaseTitle />
          </div>
        )
        }
      </div>
    </div>
  )
}

export default ProjectManagerAccessPortal;
